<template>
  <div class="content">
    <div class="content-box">
      <div class="search">
        <div class="left">
           <div style="margin-right: 10px;"><span>状态  
            <el-select size="small" v-model="logout" clearable filterable="请选择状态" class="select" @change="search" style="width:200px">
              <el-option  v-for="item in stutas" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
            </span></div>
          <div style="margin-right: 10px;"><span>车牌号 
            <el-input v-model="carNumber" @input="watchInput"  clearable size="small" placeholder="请输入车牌号" style="width: 200px"></el-input>
            </span></div>
          <span class="button" @click="doFilter">查询</span>
        </div>
        <div class="right">
          <el-upload
            v-if="isMenuExit('pro:car:import')"
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHead"
            :show-file-list="false"
            :on-success="handleAppSuccess"
            :data="uploadData"
          >
          <span class="button">导入</span>
          </el-upload>
          <span class="button" @click="exportInfo" style="margin: 0 10px">导出</span>
          <!-- v-if="isMenuExit('pro:car:add')" -->
          <span class="button"  @click="addCar">添加</span>   
          <!-- v-if="isMenuExit('pro:car:select')" -->
          <span class="button" style="margin-left: 10px"   @click="attendVisible = true">选择车库</span>
        </div>
      </div>
      <el-table
          stripe
          :data="tableData"
          height="76vh"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
        <p>{{dataText}}</p>
      </template>
      <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
      <el-table-column label="序号" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.index }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车牌号">
        <template slot-scope="scope">
          <span>{{scope.row.carNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column label="车牌类型">
        <template slot-scope="scope">
          <span>{{ scope.row.carType }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车辆司机">
        <template slot-scope="scope">
          <span>{{scope.row.personName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号">
        <template slot-scope="scope">
          <span>{{scope.row.phone}}</span>
        </template>
      </el-table-column>
      <el-table-column label="有效期" width='200'>
        <template slot-scope="scope">
          <span>{{scope.row.endTime}}</span>
        </template>
      </el-table-column>
      <el-table-column label="登记时间" width='200'>
        <template slot-scope="scope">
          <span>{{scope.row.starTime}}</span>
        </template>
      </el-table-column>
      <el-table-column label="行驶证">
        <template slot-scope="scope">
          <el-image v-if="scope.row.photo!=''" style="width: 5vh; height: 5vh;cursor: pointer;" :src="scope.row.photo" :preview-src-list="scope.row.srcList"></el-image>
          <img v-else src="../../../assets/image/zanwutupian.png" style="width: 5vh; height: 5vh;cursor: pointer;" />
        </template>
      </el-table-column>
      <!-- <el-table-column label="所属车库" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.logout==0" class="minibtn">
            <!-- v-if="isMenuExit('pro:car:edit')" -->
            <span class="table-button" @click="editFun(scope.row)" >编辑</span>
            <!-- v-if="isMenuExit('pro:car:cancel')" -->
            <span class="table-button" style="border: 1px solid rgba(236, 15, 15, 0.8);color: #EC0F0F;margin-left: 5px" @click="logOut(scope.row.carId)" >注销</span>
          </div>
          <div  v-if="scope.row.logout==1" class="minibtn">
            <span class="table-button" @click="editFun(scope.row)" v-if="isMenuExit('pro:car:edit')">编辑</span>
            <!-- v-if="isMenuExit('pro:car:edit')" -->
            <span class="table-button" style="color:#C4C4C4;margin-left: 5px" size="mini" @click="editFun(scope.row)" >已注销</span>
          </div>
          <span
            v-if="scope.row.logout==2"
            style="color:#1BD095"
            @click="wait(scope.row)"
            class="hand"
          >待审核</span>
          <span v-if="scope.row.logout==3" style="color:#f00">未通过</span>
        </template>
      </el-table-column>
     </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100, 500, 1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      >
      </el-pagination>
    </div>
    <!-- 编辑窗口 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="editFormVisible"
        center
        :append-to-body="true"
        :before-close="handleClose"
        :lock-scroll="false"
        width="30%"
      >
        <div slot="title" class="dialog-title">{{dialogTitle}}</div>
        <el-form
          :model="editForm"
          ref="editForm"
          label-width="120px"
          :label-position="labelPosition"
          :rules="rules"
        > 
          <el-form-item label="车辆司机:" prop="name">
            <el-input
              v-model="editForm.name "
              autocomplete="off"
              style="width:220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone" v-if="editForm.id==''">
            <el-input
              v-model="editForm.phone "
              autocomplete="off"
              style="width:220px"
            ></el-input>
          </el-form-item>
              <el-form-item label="手机号:" prop="phone" v-else>
            <el-input
              v-model="editForm.phone "
              autocomplete="off"
              style="width:220px"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="车牌类型:">
              <el-select
                v-model="editForm.carType"
                clearable
                filterable
                placeholder="请选择状态"
                class="select"    
                style="width:220px"
              >
                <el-option  v-for="item in carTypes" :key="item.type" :label="item.label" :value="item.value"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="车牌号:">
            <el-input
              v-model="editForm.carNumber "
              autocomplete="off"
              style="width:220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="行驶证:">
            <el-upload
              class="avatar-uploader"
              v-bind:action="uploadUrl1"
              :headers="uploadHead1"
              :data="{type:224}"
              :show-file-list="false"
              :on-success="handleIconSuccess"
            >
              <img style="width: 100%" v-if="icon" :src="icon" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="开始时间:"  prop="starTime">
            <el-date-picker
              v-model="editForm.starTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              default-time="12:00:00"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="有效时间:"  prop="endTime">
            <el-date-picker
              v-model="editForm.endTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              default-time="12:00:00"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow('editForm')" style="background: #4D6EB1">确 定</el-button>
        </div>
      </el-dialog>
        <!-- 批量下发 -->
      <el-dialog
        title="选择移入的车库"
        :visible.sync="attendVisible"
        center
        width="400px"
        :append-to-body="true"
        :lock-scroll="false"
      >
        <div slot="title" class="dialog-title">选择移入的车库</div>
        <el-select
          v-model="carport"
          clearable
          filterable
          placeholder="请选择车库"
          class="select"
          @change="changeCarport"
        >
          <el-option v-for="item in cars" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button @click="attendVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAttend()" style="background: #4D6EB1">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 导入成功 -->
      <el-dialog
        :title="dialogTitle1"
        :visible.sync="imoportVisible"
        center
        :append-to-body="true"
        :before-close="handleClose2"
        :lock-scroll="false"
        width="30%"
      >   
        <template>
          <el-table :data="tableData1" style="width: 100%" border>
            <el-table-column label="状态" >
              <template slot-scope="scope">
                <span v-if="scope.row.status==0">
                  <i class="el-icon-circle-check" style="color:#07C160"></i>
                </span>
                <span v-if="scope.row.status==1">
                  <i class="el-icon-warning-outline" style="color:#f00"></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="reason" label="原因">
              <template slot-scope="scope">
                <span v-if="scope.row.status==0" style="color:#07C160">{{scope.row.reason}}</span>
                <span v-if="scope.row.status==1" style="color:#f00">{{scope.row.reason}}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-dialog>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      var checkphone = (rule, value, callback) => {
          // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
              if (value == '') {
                  callback(new Error('请输入手机号'))
              } else if (!this.isCellPhone(value)) {
                  //引入methods中封装的检查手机格式的方法
                  callback(new Error('请输入正确的手机号!'))
              } else {
                  callback()
              }
          }
      return {
        labelPosition:'right',
        tableData: [], //获取数据
        tableData1: [],
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        projectId: '',
        serchName: '', //车库名称
        uploadUrl: myHttp.importLicenseForExcel, //上传地址
        uploadHead: {
          accessToken: util.session.get('token')
        },
        uploadData: {
          projectId: ''
        },
        dataText: '暂无数据',
        uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
        uploadHead1: {
          accessToken: util.session.get('token')
        },
        dialogTitle1: '导入',
        editFormVisible: false,
        waitFormVisible1: false,
        waitForm: {
          personId: '',
          personName: '',
          carType: '',
          drivingCarPhoto: ' ',
          id: ' ',
          starTime: '',
          endTime: ''
        },
        dialogTitle: '',
        editForm: {
          // personId: '',
          name:'',
          phone:'',
          id: '',
          carType: '',
          starTime: '',
          endTime: '',
          plateType:''
          // phone: ''
        },
        icon: '', // 行驶证图
        updateBy: '',
        userId: '',
        stutas: [
          { value: '0', name: '有效' },
          { value: '1', name: '无效' },
        ],
        logout: '',
        carNumber: '',
        multipleSelection: [],
        attendVisible: false,
        imoportVisible: false,
        attendData: [],
        attendData1: [],
        licenseIds: '', //车牌id
        cars: [],
        carport: '', //车库id
        carTypes:[],//车牌类型
        plateTypes:[],//车辆类型
        perlists:[],//人员信息列表
        rules: {
          name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          phone: [{ required: true, validator: checkphone, trigger: 'blur' }],
          endTime: [{ required: true, message: '请选择有效期', trigger: 'blur' }],
          starTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        }
      }
    },
    mounted() {
      this.projectId = util.session.get('groupId')
      this.userId = util.session.get('user').id
      this.updateBy = util.session.get('user').id
      if (this.projectId == '') {
        this.$store.commit('setGroupId')
        this.projectId = this.$store.state.groupId
      }
      ;(this.uploadData.projectId = this.projectId), this.getData()
      this.getCar()
      this.getCarType()
      this.getPersonId()
      this.getplateType()
    },
    methods: {
      //获取数据
      getData() {
        var that = this
        myHttp
          .secCarNumberByProjectId({
            projectId: this.projectId,
            carNumber: this.carNumber,
            logout: this.logout,
            pageSize: this.pageSize,
            pageNum: this.currentPage
          })
          .then(
            function(resp) {
              if (resp.data.code == '200') {
                var list = resp.data.data.licenses.list || []
                for (var i = 0; i < list.length; i++) {
                  list[i].index = that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                  list[i].photo = list[i].drivingPermit && list[i].drivingPermit!=''?base.httpCtx+list[i].drivingPermit:''
                  list[i].srcList = list[i].photo && list[i].photo!=''?[list[i].photo]:[]
                }
                that.tableData = list
                that.totalItems = resp.data.data.licenses.total
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
      },
      addCar(){
        this.dialogTitle="添加车辆"
        this.editFormVisible=true
        this.editForm = {
          // personId:'',
          phone:'',
          name:'',
          personName:'',
          carType: '',
          carNumber:'',
          id: '',
          endTime:'',
          starTime:''
        }
        this.icon = ''
      },
      // 将新增的数据添加到表格中
      sumbitAddRow(formName) {
        var that = this
        this.editForm.projectId = this.projectId
      
        this.$refs[formName].validate(valid => {
          if (valid) {
            if(that.editForm.id==''){
            myHttp.createInfoCarId(that.editForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.editFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
            }else{
            myHttp.updateEndDate(that.editForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.editFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
            }
          }
        })
      },

      argee(formName) {
        console.log(formName)
        var that = this
        this.$refs[formName].validate(valid => {
          if (valid) {
            that.waitForm.logout = 4
            myHttp
              .updateInfoNumber({
                logout: 4,
                id: that.waitForm.id,
                star: that.waitForm.starTime,
                end: that.waitForm.endTime,
                projectId: this.projectId
              })
              .then(
                function(resp) {
                  if (resp.data.code == '200') {
                    that.$message.success(resp.data.msg)
                    that.waitFormVisible1 = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function() {}
              )
          }
        })
      },
      argeeNot(formName) {
        // console.log(formName)
        var that = this
        this.$refs[formName].validate(valid => {
          if (valid) {
            myHttp
              .updateInfoNumber({
                logout: 3,
                id: that.waitForm.id,
                star: that.waitForm.starTime,
                end: that.waitForm.endTime,
                projectId: this.projectId
              })
              .then(
                function(resp) {
                  if (resp.data.code == '200') {
                    that.$message.success(resp.data.msg)
                    that.waitFormVisible1 = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function() {}
              )
          }
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      // 监控当前页码
      currentChangePage(list) {
        this.getData()
      },
      // 编辑弹框
      editFun(row) {
        this.dialogTitle = '修改车牌'
        this.editFormVisible = true
        this.editForm = {
          // personId: row.personId,
          phone:row.phone,
          name:row.personName,
          personName: row.personName,
          carType: row.value,
          carNumber:row.carNumber,
          id: row.carId,
          endTime:row.endTime,
          phone: row.phone,
          vehicleCategory:row.vehicleCategory,
          starTime:row.starTime
        }
        this.icon =row.drivingPermit && row.drivingPermit != '' ? base.httpCtx + row.drivingPermit: ''
      },
    
      // 注销
      logOut(id) {
        var that = this
        this.$confirm('此操作将永久注销该车牌, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            myHttp
              .logoutCar({
                projectId: this.projectId,
                id: id
              })
              .then(function(resp) {
                if (resp.data.code == '200') {
                  that.$message({
                    type: 'success',
                    message: '注销成功!'
                  })
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
          })
          .catch(err => {})
      },
      // 导出
      exportInfo() {
        var token = this.$store.state.token
        window.open(
          myHttp.exportLicenseForExcel +
            '?projectId=' +
            this.projectId +
            '&carNumber=' +
            this.carNumber +
            '&logOut=' +
            this.logout +
            '&accessToken=' +
            token
        )
      },
      doFilter() {
        this.getData()
      },
      //
      handleChange(e) {
        this.editForm.useType = e.value
        // console.log(e.value)
      },

      //上传成功监听方法
      handleAppSuccess(res, file) {
        if (res.code == '200') {
          this.imoportVisible = true
          this.tableData1 = res.data.list
          this.getData()
        } else {
          this.$message.error(res.msg)
        }
      },
      // 上传图片
      handleIconSuccess(res, file) {
        this.icon = URL.createObjectURL(file.raw)
        this.editForm.drivingCarPhoto = res.data.savePhotoUrls
      },
      // 查询
      search() {
        this.getData()
      },
      // 关闭弹出框弹窗
      handleClose(done) {
        this.editFormVisible = false
      },
      handleClose1(done) {
        this.waitFormVisible1 = false
      },
      handleClose2(done) {
        this.imoportVisible = false
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
        console.log(this.multipleSelection)
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (i == 0) {
            this.licenseIds = this.multipleSelection[i].carId
          } else {
            this.licenseIds += ',' + this.multipleSelection[i].carId
          }
          console.log(this.licenseIds)
        }
      },
      // 弹出框列表
      getList() {
        var that = this
        myHttp
          .secCarportAndCamera({
            projectId: this.projectId
          })
          .then(
            function(resp) {
              if (resp.data.code == '200') {
                var list = resp.data.data.carportInfo || []
                that.attendData = list
                for (var i = 0; i < list.length; i++) {
                  // list[i].direction = list[i].direction == 1 ? '进闸' : '出闸'
                  list[i].index = parseInt(i + 1)
                }
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
      },
      // 获取车库列表
      getCar() {
        var that = this
        myHttp
          .secCarportByLikeNameList({
            projectId: this.projectId
          })
          .then(
            function(resp) {
              if (resp.data.code == '200') {
                that.cars = resp.data.data.carports || []
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
      },
      //更改车库
      changeCarport() {},
      // 选择车库
      sumbitAttend() {
        if (this.multipleSelection.length == '0') {
          this.$message({
            type: 'warning',
            message: '请选择需要选择的车牌号!'
          })
          return
        }
        var that = this
        myHttp
          .createInfocarInfo({
            licenseId: this.licenseIds,
            carportId: this.carport
          })
          .then(
            function(resp) {
              if (resp.data.code == '200') {
                that.$message.success(resp.data.msg)
                that.attendVisible = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
      },
      // 待审核和审核未通过
      selectable(row) {
        // console.log(row)
        if (row.logout == '1') {
          return false
        } else {
          return true
        }
      }, 
      /**车牌类型 */
      getCarType(){
        var that = this
          myHttp.getDictByType({
            type:'plate_type'
          }).then(function(resp){
            if(resp.data.code=='200'){
              var list = resp.data.data.dictList||[]  
              console.log(list) 
              that.carTypes = list
            }
          })
      },
      /**车辆类型 */
      getplateType(){
        var that = this
          myHttp.getDictByType({
            type:'vehicle_category'
          }).then(function(resp){
            if(resp.data.code=='200'){
              var list = resp.data.data.dictList||[]
              console.log(list)
              that.plateTypes = list
            }
          })
      },
      /**获取人员列表 */
      getPersonId(){
          var that = this
          myHttp.secZzPerson({
            projectId:this.projectId
          }).then(function(resp){
            if(resp.data.code=='200'){
              var list = resp.data.data.list||[]
              for(var i=0;i<list.length;i++){
                list[i].label = list[i].name +'('+list[i].phone+')'
              }
              that.perlists = list
            }
          })
      },
      /**
       * 判断是否展示
       */
      isMenuExit(row){
          var flag = util.common.filterBtnMenu(row)
          return flag
      },
      //检查手机号
          isCellPhone(val) {
              if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
                  return false
              } else {
                  return true
              }
          },
    }
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.table-button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-size: 14px;
  color: #8EA3CE;
  cursor: pointer;
}
.content{
  height: 100%;
  padding: 1vh 1vw;
}
.content-box{
  height: calc(100% - 2vh);
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.search{
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #D8D8D8;
  padding: 12px 18px;
}
.left{
  display: flex;
}
.right{
  display: flex;
}

/deep/ .el-dialog__header{
  padding: 0;
}
.dialog-title{
  padding: 9px 24px;
  height: 40px;
  text-align: left;
  font-size: 16px;
  color: #666666;
  background-color: #ECF0F5;
}
/deep/ .el-dialog__close{
  font-size: 24px;
}
/deep/ .el-dialog__headerbtn{
  top: 10px;
}
</style>